<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Something went wrong.</h3>
      <p class="info-text">
        Please try again. Contact us if the problem continues.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div
    *ngIf="!loading && state && !internalServerError"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <app-zaver-icon class="icon-user-img" [size]="80" name="phoneCircle" ></app-zaver-icon>
      <h1 class="heading">Verify email & phone</h1>

      <div class="img-progress-bar-wrapper">
        <img
          class="img-progress-bar"
          src="assets/icon/Phone-Progress-bar.svg"
        />
      </div>

      <p class="info-text">
        Enter the code that was sent to: {{ phoneNumberString }}
      </p>

      <div class="token-input-wrapper">
        <zaver-token-input
          (valueChange)="onOtpChange($event)"
          [showError]="showError"
          [isMobile]="isMobile"
          [IOS]="IOS"
          [maxLength]="otpLength"
        ></zaver-token-input>
      </div>

      <div class="display-error" *ngIf="showError">
        <img src="assets/icon/icon_error.svg" alt="" class="info-icon" />
        <p>The verification code is incorrect or has already&nbsp;expired</p>
      </div>

      <div class="resend-code" [ngClass]="showError ? 'error' : ''">
        <zaver-button-link
          [text]="'Send SMS again'"
          (click)="reSendCode()"
          [disabled]="navigationInProgress"
          [interactive]="true"
        ></zaver-button-link>
      </div>

      <div class="footer-wrapper">
        <div class="footer-container">
          <app-general-error
            *ngIf="!showError && noResponseError"
            class="general-error"
          ></app-general-error>
        </div>
      </div>
    </div>
  </div>
</div>
